
import { Box, Checkbox, FormControl, FormControlLabel, IconButton, MenuItem, Popover, Select, TextField, Typography } from '@mui/material';
import {usePopupState } from 'material-ui-popup-state/hooks';
import React, { useState } from 'react'
import { formatTime } from 'src/coach/service/coach.utils';
import { EventService } from 'src/event/service/event.service';
import { breakpoints, useMediaQuery } from 'src/shared/hooks/use-media-query';
import '../style.module.scss';
import * as Config from 'src/shared/config';
import { CloseIcon } from '../../../svg';

const AvailabilityModes = [
  {
    label: 'Buffer',
    value: 'buffer',
  },
  {
    label: 'Allowable Overlap',
    value: 'overlap',
  },
];
const FindCoachHeader = ({
  allowedConflicts,
  availabilityOverlapBufferMode,
  availableCoachesCount = 0,
  bufferOrOverLapTime,
  coachAvailabilityFilter,
  eventDate,
  handleClassFiltersChange,
  isBulk = false,
  onClose,
  setAllowedConflicts,
  setAvailabilityOverlapBufferMode,
  setBufferOrOverLapTime,
  staffedCoachCount = 0,
  unavailableCoachCount = 0,
}) => {
  const adminUrl = Config.ADMIN_URLS[ENVIRONMENT];

  const { event = {}, overriddenLocation } = eventDate || {};
  const {
    endTime: eventDateEndTime,
    eventDateParticipantsCount,
    startTime: eventDateStartTime,
  } = eventDate || {};

  const {
    effectiveProgramName,
    endTime: eventEndTime,
    isActiveEnrollmentsOverridden,
    location: eventLocation,
    overriddenActiveEnrollments,
    startTime: eventStartTime,
  } = event || {};
  const location = overriddenLocation?.id ? overriddenLocation : eventLocation;

  const existingStartTime = eventDateStartTime || eventStartTime;
  const existingEndTime = eventDateEndTime || eventEndTime;
  const datesLabel = EventService.dateLimits(event);
  const duration = EventService.durationLabel(event);
  const kids = isActiveEnrollmentsOverridden
    ? overriddenActiveEnrollments
    : eventDateParticipantsCount || 0;

  const [popupStateMobileAnchorEl, setPopupStateMobileAnchorEl] = useState(null);
  const [bufferPopoverAnchor, setBufferPopoverAnchor] = useState(null);
  const [conflictPopoverAnchor, setConflictPopoverAnchor] = useState(null);

  const handleBufferPopoverOpen = (event) => {
    setBufferPopoverAnchor(event.currentTarget);
  };

  const handleBufferPopoverClose = () => {
    setBufferPopoverAnchor(null);
  };

  const handleConflictPopoverOpen = (event) => {
    setConflictPopoverAnchor(event.currentTarget);
  };

  const handleConflictPopoverClose = () => {
    setConflictPopoverAnchor(null);
  };
  const handlePopoverOpen = (event) => {
    setPopupStateMobileAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setPopupStateMobileAnchorEl(null);
  };
  const isBufferMode = availabilityOverlapBufferMode === 'buffer';

  const isMobile = useMediaQuery(
    [breakpoints.mobile, breakpoints.tablet, breakpoints.desktop],
    [true, true, false],
  );
  const popupStateMobile = usePopupState({
    popupId: 'filterPopover',
    variant: 'popover',
  });

  return (
 <div className="header">
  <div className="tw-flex tw-justify-between tw-w-full tw-flex-wrap sm:tw-flex-nowrap">
    {isBulk ? (
      <div></div>
    ) : (
      <div className="info">
        <a target="_blank"  href={`${adminUrl}/classes/${event?.code}/edit`}  rel="noreferrer" >
          <h2>
            {effectiveProgramName} - {event.ageRangeLabel}
          </h2>
        </a>
        <a target="_blank"  href={`${adminUrl}/locations/${location?.id}/edit`} rel="noreferrer">
          <span>{location?.name}</span>
        </a>
        <Box display="flex" flexWrap="wrap" gap="5px">
          <span>
            {EventService.formatEventDateTime(eventDate, 'EEEE, MM/dd/yyy')}
          </span>
          {!!datesLabel && <span className="subText">({datesLabel})</span>}
        </Box>
        <Box display="flex" gap="5px">
          <span className="mainText">
            {formatTime(existingStartTime)} - {formatTime(existingEndTime)}
          </span>
          {!!duration && <span className="subText">({duration})</span>}
          {kids > 0 && (
            <a target="_blank" href={`${adminUrl}/classes/${event?.code}/roster`}  rel="noreferrer" >
              <span className="kids">
                {kids} {kids === 1 ? 'participant' : 'participants'}
              </span>
            </a>
          )}
        </Box>
        <span className="idText">
          Event ID:{event.id} | Event Date ID:{eventDate.id}
        </span>
      </div>
    )}

    <div className="action">
      {isMobile ? (
<div>
      <p
        className="popupTextWrapper"
        onClick={handlePopoverOpen} // Trigger the popover
      >
        <span className="popupText">Conflicts and Availability Filter</span>
      </p>

      <Popover
        open={Boolean(popupStateMobileAnchorEl)} // Check if anchorEl is set
        anchorEl={popupStateMobileAnchorEl} // Attach to the tracked anchor
        onClose={handlePopoverClose} // Close handler
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'top',
        }}
        transformOrigin={{
          horizontal: 'center',
          vertical: 'top',
        }}
      >
        <div style={{ padding: '10px' }}>
          <Box display="flex">
            <Box
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              gap="10px"
              justifyContent="center"
              style={{ marginRight: '10px' }}
            >
              <p
                className="popupTextWrapper"
                onClick={handleBufferPopoverOpen} // Trigger buffer popover
              >
                <span className="popupText">
                  {isBufferMode ? 'Buffer' : 'Allowable Overlap'}{' '}
                </span>
                <span className="popupText">{bufferOrOverLapTime}</span>{' '}
                minutes
              </p>
              <p
                className="popupTextWrapper"
                onClick={handleConflictPopoverOpen} // Trigger conflict popover
              >
                Max Conflicts{' '}
                <span className="popupText">{allowedConflicts}</span>
              </p>
            </Box>
          </Box>
          <div className="wrapper">
            <Box
              onChange={handleClassFiltersChange}
              display="flex"
              flexDirection="column"
              sx={{ flexWrap: { sm: 'wrap', xs: 'nowrap' } }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={coachAvailabilityFilter.available}
                    defaultChecked={coachAvailabilityFilter.available}
                  />
                }
                label={`Available (${availableCoachesCount})`}
                value="available"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={coachAvailabilityFilter.staffed}
                    defaultChecked={coachAvailabilityFilter.staffed}
                  />
                }
                label={`Staffed (${staffedCoachCount})`}
                value="staffed"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={coachAvailabilityFilter.unavailable}
                    defaultChecked={coachAvailabilityFilter.unavailable}
                  />
                }
                label={`Unavailable (${unavailableCoachCount})`}
                value="unavailable"
              />
            </Box>
          </div>
        </div>
      </Popover>
    </div>
      ) : (
        <>
          <Box display="flex">
            <Box
              display="flex"
              alignItems="center"
              flexWrap="nowrap"
              gap="10px"
              justifyContent="center"
              style={{ marginRight: '10px' }}
            >
              <p
                className="popupTextWrapper"
onClick={handleBufferPopoverOpen}
              >
                <span className="popupText">
                  {isBufferMode ? 'Buffer' : 'Allowable Overlap'}{' '}
                </span>
                <span className="popupText">{bufferOrOverLapTime}</span>{' '}
                minutes
              </p>
              <p
                className="popupTextWrapper"
               onClick={handleConflictPopoverOpen}
              >
                Max Conflicts{' '}
                <span className="popupText">{allowedConflicts}</span>
              </p>
            </Box>
          </Box>
          <div className="wrapper">
            <Box onChange={handleClassFiltersChange} display="flex" flexDirection="row" flexWrap="nowrap">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={coachAvailabilityFilter.available}
                    defaultChecked={coachAvailabilityFilter.available}
                  />
                }
                label={`Available (${availableCoachesCount})`}
                value="available"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={coachAvailabilityFilter.staffed}
                    defaultChecked={coachAvailabilityFilter.staffed}
                  />
                }
                label={`Staffed (${staffedCoachCount})`}
                value="staffed"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={coachAvailabilityFilter.unavailable}
                    defaultChecked={coachAvailabilityFilter.unavailable}
                  />
                }
                label={`Unavailable (${unavailableCoachCount})`}
                value="unavailable"
              />
            </Box>
          </div>
        </>
      )}
    </div>
  </div>
<Popover
        disableEnforceFocus
        open={Boolean(bufferPopoverAnchor)}
        anchorEl={bufferPopoverAnchor}
        onClose={handleBufferPopoverClose}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        transformOrigin={{
          horizontal: 'center',
          vertical: 'top',
        }}
      >
        <div className="headerPopoverContentWrapper">
          <div className="closeButton">
            <IconButton color="inherit" edge="end" onClick={handleBufferPopoverClose} size="small">
              <CloseIcon />
            </IconButton>
          </div>

          <Box display="flex" alignItems="center" gap="5px" mt={2}>
            <FormControl sx={{ width: 160 }}>
              <Select
                value={availabilityOverlapBufferMode}
                onChange={(e) => setAvailabilityOverlapBufferMode(e.target.value)}
              >
                {AvailabilityModes.map((mode) => (
                  <MenuItem key={mode.value} value={mode.value}>
                    {mode.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              type="number"
              value={bufferOrOverLapTime}
              onChange={(e) => setBufferOrOverLapTime(e.target.value || 0)}
              inputProps={{ min: 0 }}
              sx={{ width: 65, margin: 0 }}
            />
            <Typography>minutes</Typography>
          </Box>
        </div>
      </Popover>
 <Popover
        disableEnforceFocus
        open={Boolean(conflictPopoverAnchor)}
        anchorEl={conflictPopoverAnchor}
        onClose={handleConflictPopoverClose}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        transformOrigin={{
          horizontal: 'center',
          vertical: 'top',
        }}
      >
        <div className="headerPopoverContentWrapper">
          <div className="closeButton">
            <IconButton color="inherit" edge="end" onClick={handleConflictPopoverClose} size="small">
              <CloseIcon />
            </IconButton>
          </div>
          <Box sx={{ width: 290 }}>
            <Typography>Conflict Threshold for Availability</Typography>
            <TextField
              type="number"
              value={allowedConflicts}
              onChange={(e) => setAllowedConflicts(e.target.value || 0)}
              inputProps={{ min: 0 }}
              fullWidth
            />
          </Box>
        </div>
      </Popover>
</div>

  );
};

export default FindCoachHeader;
